module.exports = __webpack_public_path__ + "static/img/gaozhongzhengzhi4.001c3d9f.jpg";